import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { saveAs } from 'file-saver';
import { ProcessService } from 'src/app/services/process.service';

@Component({
  selector: 'app-avis-bulk-download-dialog',
  templateUrl: './avis-bulk-download-dialog.component.html',
  styleUrls: ['./avis-bulk-download-dialog.component.css']
})
export class AvisBulkDownloadDialogComponent {
  downloading = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private processService: ProcessService
  ) {}

  downloadFile(file, index) {
    this.downloading[index] = true;

    this.processService.downloadAvisBulkFile(this.data.jobId, index).subscribe(
      (blob) => {
        this.downloading[index] = false;
        saveAs(blob, file.name || ('avis_part_' + (index + 1) + '.zip'));
      },
      () => {
        this.downloading[index] = false;
      }
    );
  }

  downloadAll() {
    this.data.files.forEach((file, index) => {
      this.downloadFile(file, index);
    });
  }
}